<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog">
        <div class="content">
            <el-table stripe :data="tableData" ref="multipleTable" :height="tableHeight" :show-header="false" :border="false">
                <el-table-column show-overflow-tooltip>
                    <template #default="{ row }">
                        <i :class="deviceTypeFn(row.deviceType, row.deviceCatalog)" :title="deviceTitleFn(row.deviceType, row.deviceCatalog)"></i>
                        <span>{{ row.deviceName }}</span>
                    </template>
                </el-table-column>
                <!-- 只有数据异常才有 -->
                <template v-if="!isRegin">
                    <el-table-column prop="processTime" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ JSONFunc(row.content, false) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="processTime" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ JSONFunc(row.content, true) }}</span>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column prop="recordTime" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span class="lineHeight">{{ $timetransition(row.recordTime) }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <span style="margin-right:20px" :class="disAblePage ? 'iconNotAllow' : ''" @click="lastPageFn">
                    <i class="el-icon-d-arrow-left icon"></i>
                    <span class="cursor-pointer">{{ $t('integration.previous_page') }}</span>
                </span>

                <span :class="nextDisAblePage ? 'iconNotAllow' : ''" @click="nextPageFn">
                    <span class="cursor-pointer">{{ $t('integration.next_page') }}</span>
                    <i class="el-icon-d-arrow-right icon"></i>
                </span>
                <el-popover placement="left" width="500" trigger="hover" ref="iconTip">
                    <div>
                        <h1 style="font-size: 18px;font-weight:bold">{{ $t('integration.the_meaning_of_the_icon_is_as_follows_c') }}</h1>
                        <h2 style="line-height:40px">{{ $t('integration.device_type_type_icon_c') }}</h2>
                        <div class="tipIcon">
                            <div v-for="item in iconArray" :key="item.type">
                                <span>{{ $t(item.text) }}</span
                                >:
                                <i :class="item.icon"></i>
                            </div>
                        </div>
                    </div>

                    <i class="el-icon-question question" slot="reference"></i>
                </el-popover>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="isShowDialog = false">{{ $t('integration.close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { DEVICE_TYPE_ICON_FN } from '@/utils/iconMatch.js';
export default {
    props: ['title', 'isShow', 'tableData', 'isRegin'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    watch: {
        tableData(newVal) {
            if (newVal.length < 15) {
                this.nextDisAblePage = true;
            } else {
                this.nextDisAblePage = false;
            }
        }
    },
    data() {
        return {
            tableHeight: '400px',
            disAblePage: true,
            nextDisAblePage: false,
            // 匹配icon
            iconArray: [
                // 传感器
                {
                    deviceID: 1,
                    icon: 'iconfont icon-wenduji',
                    deviceCatalog: 0,
                    text: $t('sensorType.ZigBeeTemp')
                },
                {
                    deviceID: 2,
                    icon: 'iconfont icon-wenshiduji',
                    deviceCatalog: 0,
                    text: $t('sensorType.ZigBeeTempHum')
                },
                {
                    deviceID: 3,
                    icon: 'iconfont icon-wenduji1',
                    deviceCatalog: 0,
                    text: $t('sensorType.LoraTemp')
                },
                {
                    deviceID: 4,
                    icon: 'iconfont icon-wenshiduji1',
                    deviceCatalog: 0,
                    text: $t('sensorType.LoraTempHum')
                },
                {
                    deviceID: 5,
                    icon: 'iconfont icon-21pingjunqiwen',
                    deviceCatalog: 0,
                    text: $t('sensorType.ZetaTemp')
                },
                {
                    deviceID: 6,
                    icon: 'iconfont icon-wenshiduji2',
                    deviceCatalog: 0,
                    text: $t('sensorType.ZetaTempHum')
                },
                // 路由
                {
                    deviceID: 1,
                    icon: 'iconfont icon-wangguan',
                    deviceCatalog: 1,
                    text: $t('deviceType.gt_1')
                },
                {
                    deviceID: 2,
                    icon: 'el-icon-monitor',
                    deviceCatalog: 1,
                    text: $t('deviceType.gt_2')
                },
                // 显示屏
                {
                    deviceID: 1,
                    icon: 'iconfont icon-lcd',
                    deviceCatalog: 2,
                    text: $t('deviceType.dt_1')
                },
                // 中继
                {
                    deviceID: 1,
                    icon: 'el-icon-s-operation',
                    deviceCatalog: 3,
                    text: $t('deviceType.rt_1')
                }
            ]
        };
    },
    methods: {
        JSONFunc(content, bool) {
            content = content.replace(/\\/g, '');
            if (content) {
                let JSONContet = JSON.parse(content);
                if (bool) {
                    return `${JSONContet.min + JSONContet.unit}-${JSONContet.max + JSONContet.unit}`;
                } else {
                    return JSONContet.val + JSONContet.unit;
                }
            }
        },
        lastPageFn() {
            if (this.disAblePage) return;
            this.$parent.listQuery.iDisplayStart -= 15;
            console.log(this.$parent.listQuery);
            if (this.$parent.listQuery.iDisplayStart === 0) {
                this.disAblePage = true;
            } else {
                this.disAblePage = false;
            }
            this.$parent.abnormalList();
        },
        nextPageFn() {
            if (this.nextDisAblePage) return;
            this.disAblePage = false;
            this.$parent.listQuery.iDisplayStart += 15;
            this.$parent.abnormalList();
        },
        deviceTypeFn(type, catalog) {
            switch (catalog) {
                case 0: {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'icon');
                }
                case 1: {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'icon');
                }
                case 2: {
                    return DEVICE_TYPE_ICON_FN('display', type, 'icon');
                }
                case 3: {
                    return DEVICE_TYPE_ICON_FN('delay', type, 'icon');
                }
                default:
                    break;
            }
        },
        deviceTitleFn(type, catalog) {
            switch (catalog) {
                case 0: {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'title');
                }
                case 1: {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'title');
                }
                case 2: {
                    return DEVICE_TYPE_ICON_FN('display', type, 'title');
                }
                case 3: {
                    return DEVICE_TYPE_ICON_FN('delay', type, 'title');
                }
                default:
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    min-height: 300px;

    .lineHeight {
        line-height: 40px;
    }

    .iconNotAllow {
        cursor: not-allowed;
    }

    ::v-deep .el-table__cell {
        border-right: 0 !important;
    }
}

.pagination {
    position: relative;
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
        cursor: pointer;
    }

    .question {
        position: absolute;
        right: 0;
    }
}

.tipIcon {
    display: flex;
    flex-wrap: wrap;
    line-height: 40px;

    i {
        margin-right: 20px;
    }
}
</style>
